import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import { VButtonDropdownComponent } from "@directives/_core/v-dropdown/v-button-dropdown/v-button-dropdown.component";
import { DriverStatus, IDriver } from "@interfaces/IDriver";
import { IVehicle } from "@interfaces/IVehicle";
import { DriverService } from "@services/driver.service";
import { FilterBarComponent } from "../filter-bar.component";
import { FilterTriggerType, IFilterBarFilter } from "../filter-bar.models";
import "./driver-button-filter.component.scss";

@Component({
    selector: "driver-button-filter",
    template: require("./driver-button-filter.component.html")
})
export class DriverButtonFilterComponent implements IFilterBarFilter<IVehicle> {
    @Input() selected: IDriver;
    @Input() label = "All Drivers";
    @Input() showAllItems = false;
    @Output() change = new EventEmitter<IDriver>();

    @ViewChild(VButtonDropdownComponent) dropdown: VButtonDropdownComponent;

    // ---

    name = "Driver";
    icon = "fa-solid fa-duotone fa-user";
    type: FilterTriggerType = "driver";

    drivers: IDriver[];

    itemPromise: angular.IPromise<any>;

    constructor(
        private readonly parent: FilterBarComponent,
        readonly elementRef: ElementRef<HTMLElement>,
        readonly driverService: DriverService
    ) {

    }

    onFilterOpen(): void {
        this.itemPromise = this.driverService.getDrivers().then(drivers => {
            this.drivers = drivers;

            // Todo: Move to driver service
            this.drivers.sort((d1, d2) => {
                if (d1.Status == DriverStatus.Active && d2.Status == DriverStatus.Inactive) {
                    return -1;
                }

                if (d1.Status == DriverStatus.Inactive && d2.Status == DriverStatus.Active) {
                    return 1;
                }

                return d1.DisplayName.localeCompare(d2.DisplayName);
            });
        });
    }

    filterPredicate(item: any, value?: IDriver): boolean {

        if (item.DriverId) {
            return item.DriverId == value.Id;
        }

        return false;
    }

    searchPredicate = (item: IDriver, value?: any): boolean => {
        return this.driverService.driverSearchPredicate(item, value);
    }

    onDriverClick(driver: IDriver): void {
        this.selected = driver;

        this.change.emit(driver);
        this.parent.onFilterChange("driver", driver);

        if (this.selected) {
            this.label = driver.DisplayName;
        }
        else {
            this.label = "All Drivers";
        }
    }

    clearSelectedDriver(): void {
        this.onDriverClick(null);
    }
}
